// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          regComplete: false,
          allowPrimaryDomainAccess: false,
          name: "",
          logo: undefined,
          timeZone: ""
        };
}

function id(t) {
  return t.id;
}

function regComplete(t) {
  return t.regComplete;
}

function allowPrimaryDomainAccess(t) {
  return t.allowPrimaryDomainAccess;
}

function logo(t) {
  return t.logo;
}

function name(t) {
  return t.name;
}

function timeZone(t) {
  return t.timeZone;
}

function setName(t, name) {
  return {
          id: t.id,
          regComplete: t.regComplete,
          allowPrimaryDomainAccess: t.allowPrimaryDomainAccess,
          name: name,
          logo: t.logo,
          timeZone: t.timeZone
        };
}

function setLogo(t, logo) {
  return {
          id: t.id,
          regComplete: t.regComplete,
          allowPrimaryDomainAccess: t.allowPrimaryDomainAccess,
          name: t.name,
          logo: logo,
          timeZone: t.timeZone
        };
}

function setTImeZone(t, timeZone) {
  return {
          id: t.id,
          regComplete: t.regComplete,
          allowPrimaryDomainAccess: t.allowPrimaryDomainAccess,
          name: t.name,
          logo: t.logo,
          timeZone: timeZone
        };
}

function setAllowPrimaryDomainAccess(t, allowPrimaryDomainAccess) {
  return {
          id: t.id,
          regComplete: t.regComplete,
          allowPrimaryDomainAccess: allowPrimaryDomainAccess,
          name: t.name,
          logo: t.logo,
          timeZone: t.timeZone
        };
}

function togglePrimaryDomainAccess(t) {
  return {
          id: t.id,
          regComplete: t.regComplete,
          allowPrimaryDomainAccess: !t.allowPrimaryDomainAccess,
          name: t.name,
          logo: t.logo,
          timeZone: t.timeZone
        };
}

function decode(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          regComplete: Json_decode.field("reg_complete", Json_decode.bool, json),
          allowPrimaryDomainAccess: Json_decode.field("allow_primary_domain_access", Json_decode.bool, json),
          name: Json_decode.field("name", Json_decode.string, json),
          logo: Json_decode.optional((function (param) {
                  return Json_decode.field("logo", Json_decode.string, param);
                }), json),
          timeZone: Json_decode.field("time_zone", Json_decode.string, json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "allow_primary_domain_access",
                t.allowPrimaryDomainAccess
              ],
              tl: /* [] */0
            });
}

exports.empty = empty;
exports.id = id;
exports.regComplete = regComplete;
exports.allowPrimaryDomainAccess = allowPrimaryDomainAccess;
exports.name = name;
exports.logo = logo;
exports.timeZone = timeZone;
exports.setTImeZone = setTImeZone;
exports.setName = setName;
exports.setLogo = setLogo;
exports.setAllowPrimaryDomainAccess = setAllowPrimaryDomainAccess;
exports.togglePrimaryDomainAccess = togglePrimaryDomainAccess;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
